import { render, staticRenderFns } from "./WorksTopSlot.vue?vue&type=template&id=7b2c5f2d"
import script from "./WorksTopSlot.vue?vue&type=script&lang=js"
export * from "./WorksTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports